import React,{useEffect,useState} from 'react';
import {HorizontalBar,Bar} from 'react-chartjs-2';
import {Card,CardContent,Box, Typography} from "@material-ui/core";

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  contenedorCard:{
    //paddingRight:'3rem'
    height:10+'rem',marginRight:".3rem"
  },
  card:{
    boxShadow:'0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%)',
    //color:'#4a4a4a',
  },
  tituloGraf:{
    paddingTop:'0rem',
    textAlign:'center'
  },
  nested: {
    paddingLeft: theme.spacing(2),
  },
}));

export default function Graficas({valor}){
  const classes = useStyles();
  const auxColor=process.env.REACT_APP_Fondo_Color
  const [data,setData]= useState([]);
  const [datTarea,setDatTarea]= useState([]);
  const [bandera,setBandera]= useState(false);
  useEffect(()=>{    
    let nvoArr=[], nvoArr2=[]
    if (valor.SolicitudStatus.length !== 0 ) {     
      valor.SolicitudStatus.forEach(element => {
        nvoArr.push({ 
          label:element.Nom,
          type: 'bar',
          data: [element.Total], 
          backgroundColor:element.Col,
          borderColor: element.Col,
          //fill: false,
          tension: 0.4     
        })
      });
    }
    if (valor.TareaStatus.length !== 0 ) {      
      valor.TareaStatus.forEach(element => {
        nvoArr2.push({ 
          label:element.Nom,
          type: 'bar',
          data: [element.Total], 
          backgroundColor:element.Col,
          borderColor: element.Col,
          //fill: false,
          tension: 0.4     
        })
      });
    }
    setData(nvoArr)
    setDatTarea(nvoArr2)
    
    setBandera(true)
  },[valor])

  const dataGenero = {
    labels: ['Estatus de Solicitudes'],
    datasets:data,
  }; 

  const dataTarea = {
    labels: ['Estatus de Expedientes'],
    datasets:datTarea
  }; 

  const options = {
  
  //  indexAxis:'y',
    tooltips: {
      enabled: true,
    },
   /*  layout: {
      padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
      }
    }, */
    title:{
      fontStyle: 'bold',
    },
    scales: {
      x: {
          display: true,
          title: {
          display: true
          }
      },
      y: {
          display: true,
          title: {
          display: false,
       
          },
       
      },
      }
   /*  scales: {
      x: {
        stacked: true,
        ticks: {
          beginAtZero: true,
        },
      },
      y: {
        stacked: true,
        labe :{
          fontSize:6,
        },
      }
    
    }, */
  } 

  function  llenadoTabla2(datos,)
  {
    return(
    <Card className={classes.card} style={{paddingRight:.8+'rem',paddingLeft:.8+'rem' 
      ,paddingBottom:.5+'rem',height:11+'rem',width:25+'rem'}} >              
      <Bar
        id="graficaMuni"
        data={datos}
        width={400} height={200} 
        options={options}
      />   
    </Card>
    );
  }

  return (
  <Box display="flex" flexDirection="row" justifyContent={'center'} mb={1} style={{marginTop:1+'rem',}} >           
     <Box display="flex"className={classes.contenedorCard}  >
        {bandera ?llenadoTabla2(dataGenero,):null}
      </Box>      
      <Box display="flex"className={classes.contenedorCard}  >
        {bandera ?llenadoTabla2(dataTarea,):null}
      </Box>     
     
  </Box>
  );
}